import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import useStyles from "../assets/styles/useStyles";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.daisun.fr/">
        DaiSun
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


const footers = [
  {
    title: 'Site Web',
    description: ['https://www.daisun.fr/'],
    href: 'https://www.daisun.fr'
  },
  {
    title: 'Adresse',
    description: ['6-8 Allée Léon Gambetta 13001, Marseille'],
    href: '#'
  },
  {
    title: 'Téléphone',
    description: ['09 86 42 50 21'],
    href: '#'
  },
  {
    title: 'Email',
    description: ['contact@daisun.solar'],
    href: '#'
  },

];

export default function ComingSoon() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      {/* Hero unit */}
      <Container maxWidth="sm" component="main" className={classes.heroContentCs}>
        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
        Bientôt disponible
        </Typography>
      </Container>
      {/* Footer */}
      <Container maxWidth="md" component="footer" className={classes.footerCs}>
        <Grid container spacing={4} justifyContent="space-evenly">
          {footers.map((footer) => (
            <Grid item xs={6} sm={3} key={footer.title}>
              <Typography variant="h6" color="textPrimary" gutterBottom>
                {footer.title}
              </Typography>
              <ul>
                {footer.description.map((item) => (
                  <li key={item}>
                    <Link href={footer.href} variant="subtitle1" color="textSecondary">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </Grid>
          ))}
        </Grid>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
      {/* End footer */}
    </React.Fragment>
  );
}